import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';

const useTheme = (): {
    theme: string;
    setTheme: (theme: string) => void;
} => useContext(ThemeContext);

export default useTheme;
